import { createSelector } from 'reselect'
import getByCartItemsVariantIdDataProductsSelector from 'modules/product/redux/selectors/get-by-cart-item-variant-id-data'
import getByVariantIdDeepProductSelector from 'modules/product/redux/selectors/get-by-variant-id-deep'

const getDealExpiryDateSelector = (variantId) => createSelector(
  getByCartItemsVariantIdDataProductsSelector(variantId),
  getByVariantIdDeepProductSelector(variantId),
  (cartItem, deepProduct) => {
    return cartItem?.deals_info?.end_time || deepProduct?.deals_info?.end_time
  }
)

export default getDealExpiryDateSelector
